import axios from 'axios'
import { HEADER, CAPITALIZEFIRSTLETTER, TOKENIDENTITY } from '../constants'
import { URL, LOCAL } from '../config'

const EXCLUDED_CENTERS = [306, 307, 70]; // IDs de centros a excluir

export default class Center {
  static INSTANCE = new Center();

  listCenter = [
    {
      id: 50,
      name: 'Bolera Gorbea'
    },
    {
      id: 43,
      name: 'Bolera Xanadu'
    }
  ];

  Center() {}

  getListCenter = async (token) => {
    if (!LOCAL) {
      let url = `${URL()}/Centros/GetCentrosProvince`
      if (token) {
        return await axios.get(url, HEADER(token)).then(response => {
          response.data.listCenter = response.data.listCenter
            .filter(item => !EXCLUDED_CENTERS.includes(item.id))
            .map(item => {
              return {
                id: item.id,
                name: CAPITALIZEFIRSTLETTER(item.name),
                idProvince: item.idProvince
              }
            })

          this.listCenter = response.data
          return this.listCenter
        })
      } else {
        return TOKENIDENTITY().then(headerWithToken => {
          return axios
            .get(url, headerWithToken).then(response => {
              response.data.listCenter = response.data.listCenter.filter(
                item => !EXCLUDED_CENTERS.includes(item.id)
              )
              return response.data
            })
        })
      }
    } else {
      return this.listCenter
    }
  };
}
